import { combineReducers } from "redux";
import notificationReducers from "./NotificationReducers";
import configReducer from "./ConfigReducer";
import localesReducer from "./LocalesReducer";

export default combineReducers({
  notifications: notificationReducers,
  config: configReducer,
  locales: localesReducer,
});
